import { FlagStatus } from '@modules/HappinessModule/enums/FlagStatus';

export const checkIfFlagResolved = (status: FlagStatus) =>
  status === FlagStatus.Negative || status === FlagStatus.Positive;
